import React from 'react'
import { observer } from 'mobx-react'
import Wrapper from '../../Contractor/Wrapper'
import { CompanyHeader_v2 } from '../InvoiceDetails/components/CompanyHeader'
import { OtherInvoiceInfo_v2 } from '../InvoiceDetails/components/OtherInvoiceInfo'
import { Divider } from 'react-native-paper'
import { FooterLoginButton } from '../InvoiceDetails/components/FooterLoginButton'
import { InvoiceIsPaidInfo } from '../InvoiceDetails/components/InvoiceIsPaidInfo'
import { InvoicePaymentProcessingInfo } from '../InvoiceDetails/components/InvoicePaymentProcessingInfo'
import {
  IntegrationRedirectStatusesType,
  LOAN_APPLICATION_STATUS,
  OPERATION_STATUS,
} from '@linqpal/models/src/dictionaries'
import { FooterRedirectBackButton } from './components/FooterRedirectBackButton'
import { determinePaymentStatus } from './helpers/determinePaymentStatus'
import { useTranslation } from 'react-i18next'

interface JwtInvoiceDetailsIdleProps {
  invoice: any
  invoicePaymentStatus: string | null
  invoiceCreditStatus: string | null
  isInvoicePaid: boolean
  onRedirectBack: (status: IntegrationRedirectStatusesType) => Promise<void>
  onPress: () => void
  isWeb: boolean
}

export const JwtInvoiceDetailsIdle: React.FC<JwtInvoiceDetailsIdleProps> =
  observer(
    ({
      invoice,
      isInvoicePaid,
      onPress,
      invoicePaymentStatus,
      invoiceCreditStatus,
      onRedirectBack,
      isWeb,
    }) => {
      const { t } = useTranslation('global')
      const renderFooterButton = () => {
        if (isInvoicePaid) {
          const paymentStatus = determinePaymentStatus(
            invoicePaymentStatus,
            invoiceCreditStatus,
          )
          return (
            <FooterRedirectBackButton
              onPress={() => onRedirectBack(paymentStatus)}
              styles={{
                paddingHorizontal: 24,
                paddingVertical: 32,
                justifyContent: 'center',
              }}
            />
          )
        } else if (!isInvoicePaid) {
          return (
            <FooterLoginButton
              title={t('integrations.buttons.login-to-pay')}
              onPress={onPress}
              styles={{
                paddingHorizontal: 24,
                paddingVertical: 32,
                justifyContent: 'center',
              }}
            />
          )
        }
        return null
      }

      return (
        <Wrapper
          containerStyle={{ alignSelf: 'center' }}
          contentContainerStyle={{ height: '100%' }}
          footer={renderFooterButton()}
          styleWidth={!isWeb ? '100%' : null}
        >
          <CompanyHeader_v2
            name={invoice.company.name}
            phone={invoice.company.phone}
            totalAmount={Number(invoice.total_amount)}
            style={{
              paddingVertical: 20,
              flexDirection: 'row',
            }}
          />

          <Divider style={{ marginBottom: 14 }} />
          <OtherInvoiceInfo_v2
            type={invoice.type}
            invoice_number={invoice.invoice_number}
            invoice_due_date={invoice.invoice_due_date}
          />

          {((isInvoicePaid &&
            invoicePaymentStatus === OPERATION_STATUS.SUCCESS) ||
            invoiceCreditStatus === LOAN_APPLICATION_STATUS.CLOSED) && (
            <InvoiceIsPaidInfo isWeb={isWeb} />
          )}
          {((isInvoicePaid &&
            invoiceCreditStatus !== LOAN_APPLICATION_STATUS.CLOSED) ||
            (isInvoicePaid &&
              invoicePaymentStatus === OPERATION_STATUS.PROCESSING)) && (
            <InvoicePaymentProcessingInfo isWeb={isWeb} />
          )}
        </Wrapper>
      )
    },
  )
